import React from "react";
import "./css/competitions.css";
import PropTypes from "prop-types";

const Competitions = ({
  exhibitions = [],
  services = false,
  numberRow = 4,
}) => {
  const colSize = 12 / numberRow;
  return (
    <div className="container my-5">
      <div className="row g-4 justify-content-center">
        {exhibitions.map((expo, index) => (
          <div
            key={index}
            className={`col-12 col-sm-6 col-md-${colSize} d-flex justify-content-center`}
          >
            <div
              onContextMenu={(e) => e.preventDefault()}
              className="card border-0 shadow position-relative rounded-4 overflow-hidden exhibition-card-image-hv"
              style={{
                backgroundImage: `url(${expo.img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                aspectRatio: "1 / 1.25",
                width: "100%",
                maxWidth: "320px",
              }}
            >
              <div
                className={`position-absolute bg-white shadow rounded-top-4 p-3 text-center ${
                  services
                    ? "exhibition-card-text-services-hv"
                    : "exhibition-card-text-hv"
                }`}
                style={{
                  bottom: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "85%",
                }}
              >
                <div className="text-barlow-bold-hv">
                  {expo.title.replace(/ (\S+)$/, "\u00A0$1")}
                </div>

                {services ? (
                  <p className="text-barlow-regular-hv mb-0">
                    {expo.subtitle.replace(/ (\S+)$/, "\u00A0$1")}
                  </p>
                ) : (
                  <>
                    <p className="text-barlow-bold-subtitle-hv mb-2 mt-3">
                      {expo.subtitle}
                    </p>
                    <p className="text-barlow-regular-hv mb-0">{expo.place}</p>
                    <p className="text-barlow-regular-hv">
                      {expo.location} <br /> {expo.year}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Competitions.propTypes = {
  exhibitions: PropTypes.any,
  services: PropTypes.bool,
  numberRow: PropTypes.number,
};

export default Competitions;
